import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";

import Page from "@/components/Page";
import Loading from "@/components/Loading";
import Breadcrumbs from "@/components/Breadcrumbs";
import MainActions from "@/components/MainActions";
import CardsContainer from "@/components/CardsContainer";
import CardsList from "@/components/CardsList";
import CardsTable from "@/components/CardsTable";
import VLFModal from "@/components/Modal";

import {SeasonAPI, refreshSeasons} from "@/api/season";
import moment from "moment";

import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

import {SUCCESSFUL_OPERATION, ERROR_OPERATION} from "@/utils/constants";

function SettingsSeasonsPage(props) {
	const {handleNotification} = props;

	const navigate = useNavigate();

	const [loading, setLoading] = useState(true);
	const [seasons, setSeasons] = useState([]);

	const [id, setId] = useState();
	const [openHandleConfirm, setOpenHandleConfirm] = useState(false);

	const getSeasons = async () => {
		setLoading(true);
		try {
			const response = await refreshSeasons();
			setSeasons(response || []);
		} catch (error) {
			handleNotification(ERROR_OPERATION, "error");
		} finally {
			setLoading(false);
		}
	};

	const deleteSeason = async () => {
		setLoading(true);
		try {
			await SeasonAPI.delete(id);
			await getSeasons();
			handleNotification(SUCCESSFUL_OPERATION, "success");
		} catch (error) {
			handleNotification(
				typeof error.response?.data === "string"
					? error.response.data
					: ERROR_OPERATION,
				"error",
			);
		} finally {
			setLoading(false);
			setOpenHandleConfirm(false);
		}
	};

	useEffect(() => {
		getSeasons();
	}, []);

	const listConfiguration = {
		data: seasons,
		imageUrl: () => require("@/assets/images/manager/category.png"),
		title: (season) => season.name,
		subtitle: (season) =>
			moment(season.startDate).format("DD/MM/YYYY") +
			" – " +
			moment(season.endDate).format("DD/MM/YYYY"),
		actions: [
			{
				icon: <EditIcon />,
				variant: "outlined",
				title: "Modifica",
				onClick: (season) =>
					navigate("/settings/seasons/" + season.id + "/edit"),
			},
			{
				icon: <DeleteIcon />,
				variant: "outlined",
				title: "Elimina",
				onClick: (season) => {
					setId(season.id);
					setOpenHandleConfirm(true);
				},
				color: "error",
			},
		],
	};

	const columns = [
		{label: "Nome", key: "name", align: "start"},
		{
			label: "Data inizio",
			key: "startDate",
			align: "center",
			customRender: (item) => moment(item.startDate).format("DD/MM/YYYY"),
		},
		{
			label: "Data fine",
			key: "endDate",
			align: "center",
			customRender: (item) => moment(item.endDate).format("DD/MM/YYYY"),
		},
	];

	const headerActions = [
		{
			icon: <AddIcon />,
			title: "Nuova stagione",
			onClick: () => navigate("/settings/seasons/new"),
		},
	];

	return (
		<Page>
			<Loading visible={loading} />
			<Breadcrumbs
				current="Stagioni"
				actions={<MainActions actions={headerActions} />}
			/>
			<CardsContainer
				tableComponent={
					<CardsTable
						breadcrumbs
						configurationColumns={columns}
						data={seasons}
						fullWidth
						rowActions
						handleEdit={(item) =>
							navigate("/settings/seasons/" + item.id + "/edit")
						}
						handleDelete={(item) => {
							setId(item.id);
							setOpenHandleConfirm(true);
						}}
						defaultSortedField="startDate"
						defaultSortedOrder="descend"
					/>
				}
				listComponent={
					<CardsList
						type="season"
						breadcrumbs
						listConfiguration={listConfiguration}
						defaultSortedField="startDate"
						defaultSortedOrder="descend"
					/>
				}
			/>
			<VLFModal
				open={openHandleConfirm}
				title="Eliminazione"
				content={
					<div className="mt-2">
						Sei sicuro di voler eliminare questo elemento?
					</div>
				}
				confirm={deleteSeason}
				close={() => setOpenHandleConfirm(false)}
				confirmLabel="Conferma"
			/>
		</Page>
	);
}

export default SettingsSeasonsPage;
